import { applyHostPrimary } from './applyHostPrimary';
import { normalizeHexForCompare } from './colorDerivation';
import { HAIC_L1_PRIMARY_ANCHOR_VAR } from './hostPrimaryVars';

/**
 * Host primary anchor from server-injected `data-primary-color` on `<body>` (#8066).
 * Also checks `<html>` for manual DevTools testing.
 */
const readHostPrimaryAnchor = (): string | null =>
  document.body.getAttribute('data-primary-color') ?? document.documentElement.getAttribute('data-primary-color');

/**
 * Reads `data-primary-color` and applies the new-tree host-primary bridge when the modern
 * design mounts. Legacy `--h2o-*` tinting stays on `@shared-legacy/theme` at bootstrap (untouched).
 */
export const applyHostTheme = (): void => {
  const primary = readHostPrimaryAnchor();
  if (!primary) return;

  const root = document.documentElement;
  // `--color-primary-500` aliases this var, so the HAIC anchor is the single source for the guard.
  const current = getComputedStyle(root).getPropertyValue(HAIC_L1_PRIMARY_ANCHOR_VAR).trim();

  if (current && normalizeHexForCompare(current) === normalizeHexForCompare(primary)) {
    return;
  }

  applyHostPrimary(primary, root);
};

/** Dev-only: re-run after editing `data-primary-color` in DevTools without a full reload. */
export const exposeHostThemeDevTools = (): void => {
  if (!import.meta.env.DEV) return;
  (window as Window & { __haicApplyHostTheme?: () => void }).__haicApplyHostTheme = applyHostTheme;
};
